// extracted by mini-css-extract-plugin
export default {"link":"recordAndBenefit_link__VDkeB","pagination":"recordAndBenefit_pagination__C5jPD","container":"recordAndBenefit_container__77TD7"};